import React from 'react';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import WorkIcon from '@mui/icons-material/Work';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const EmployeeStatsCards = ({ stats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={4}
      gridProps={{ xs: 12, sm: 6, md: 3 }}
      containerSx={{ marginY: 3 }}
    >
      <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Total Employees
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <PeopleAltIcon color="primary" />
              <Typography variant="h5">{stats.total_employees || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Active Employees
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <WorkIcon color="primary" />
              <Typography variant="h5">{stats.active_employees || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Departments
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <EmailIcon color="primary" />
              <Typography variant="h5">{stats.departments_count || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Inactive Employees
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <PhoneIcon color="primary" />
              <Typography variant="h5">{stats.inactive_employees || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </LoadingWrapper>
  );
};

export default EmployeeStatsCards;
